/*
 * DJSD-1426 — Delticore pay-before-order (preorder) flow, first rollout wave (iDEAL, Trustly).
 *
 * Step 3 (checkout review) pay action — replaces the standard order button while the flow
 * is active (reviewfooter JSP/Thymeleaf, FooterReviewRenderer):
 *   click Pay -> POST /delticore/payment/preorder/init -> redirect to the Payment Server
 *   PSP returns the customer to /delticore/payment/preorder/callback/success|failed/{sessionId}
 *
 * Before the init, the review-step form is posted to /checkout/update so its fields (newsletter
 * opt-ins, comments) reach the checkout state like a standard step submit.
 *
 * Failure behaviour: a failed/cancelled PSP payment is routed back to the payment step
 * (step 2) server-side, where the failure notice is surfaced through the existing
 * isDelticoreFailurePayment chain (delticore.js .payment-cancelled-notice). If the init
 * call itself fails, nothing was paid and no order exists — the customer is sent back to
 * step 2 as well to pick another payment method. After the backend-enforced retry limit
 * (HTTP 417 EXPECTATION_FAILED) further inits for that method are rejected server-side.
 */
$(document).ready(function () {

    function collectBrowserInfo() {
        return {
            language: navigator.language || '',
            screenWidth: window.screen ? window.screen.width : null,
            screenHeight: window.screen ? window.screen.height : null,
            colorDepth: window.screen ? window.screen.colorDepth : null,
            timeZoneOffset: new Date().getTimezoneOffset(),
            javaEnabled: navigator.javaEnabled ? navigator.javaEnabled() : false,
            javaScriptEnabled: true,
            acceptHeaders: '',
            userAgent: navigator.userAgent
        };
    }

    function preorderConfig() {
        return window.delticorePreorderConfig || {};
    }

    function returnToPaymentStep() {
        // Init failed before any payment: no order was created — back to the payment step.
        window.location.href = preorderConfig().step2Url || '/checkout/ng/step2';
    }

    function csrfToken() {
        return $("input[name='_csrf']").val();
    }

    // The review-step form (newsletter opt-ins, comments, ...) is never submitted in the
    // pay-before-order flow — the order is placed by the payment callback. Hand its fields to the
    // checkout updaters (/checkout/update, same handling as the standard step submit) instead.
    function reviewForm($origin) {
        var $form = $origin && $origin.length ? $origin.closest('form') : $();
        if (!$form.length) {
            $form = $('#checkout-step-3');
        }
        return $form;
    }

    function syncReviewForm($origin) {
        var $form = reviewForm($origin);
        if (!$form.length) {
            return $.Deferred().resolve().promise();
        }
        return $.ajax({
            url: preorderConfig().updateUrl || '/checkout/update',
            type: 'POST',
            data: $form.serialize(),
            headers: {
                "X-CSRF-TOKEN": csrfToken()
            }
        });
    }

    // Review-step Amazon Pay button (pay-before-order): the buyer leaves through the Amazon
    // sheets, so the fields of the form holding the button are synced as they change.
    $(document).on('change', 'form input, form select, form textarea', function () {
        // Step 2 renders the button inside #additionalamazonDelticore — never sync that form.
        if ($('#additionalamazonDelticore').length) {
            return;
        }
        var $amazonForm = $('#amazonDelticoreButton').closest('form');
        if ($amazonForm.length && $amazonForm.is($(this).closest('form'))) {
            syncReviewForm($(this));
        }
    });

    $(document).on('click', '.j-delticore-preorder-pay', function () {
        var $button = $(this);
        $button.prop('disabled', true);

        // A failed sync must not block the payment: the fields are informational.
        syncReviewForm($button).always(function () {
            initPreorderPayment($button);
        });
    });

    function initPreorderPayment($button) {
        $.ajax({
            url: preorderConfig().initUrl || '/delticore/payment/preorder/init',
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify({
                paymentMethod: $button.data('payment-method'),
                browserInfo: collectBrowserInfo()
            }),
            headers: {
                "X-CSRF-TOKEN": csrfToken()
            },

            success: function (response) {
                // redirectLink is the Payment Server page, or — when this checkout's payment is
                // already made — the shop callback that completes the order.
                if (response && response.redirectLink) {
                    window.location.href = response.redirectLink;
                } else {
                    returnToPaymentStep();
                }
            },

            error: function () {
                returnToPaymentStep();
            }
        });
    }
});
